import * as React from 'react';
import { Redirect, Route } from 'react-router';

import {isSessionValid, isTokenValid} from '../utils/sessionUtils';

function SecuredRoute( {children, ...rest } ) {

    return (
      <Route
        {...rest}
        render={({ location }) =>
          isTokenValid() ? (
            children
          ) : (
            <Redirect to={{ pathname: "/", state: { from: location } }} />
          )
        }
      />
    );
}

export default SecuredRoute;